import { GenerateFinancePaymentReportParams } from 'chaika-frontend-types/frontend-cms';
import uniq from 'lodash/uniq';

import { FinancePaymentApi } from '@api';
import { store } from '@store';
import { downloadFile } from '@utils/downloadFile';
import { translate } from '@chaika/i18n/helper';

class PaymentsService {
    public async loadByIds(ids: string[]): Promise<void> {
        const { paymentsList } = store.paymentsStore;
        const missing = uniq(ids).filter(id => !paymentsList.has(id));

        if (missing.length === 0) {
            return;
        }

        const { payments } = await FinancePaymentApi.find({ id: missing.join(',') });

        paymentsList.addIfNotExist(payments);
    }

    public async generateExcelReport(
        params: GenerateFinancePaymentReportParams,
        legalEntityName: string,
    ): Promise<void> {
        const file = await FinancePaymentApi.generateReport(params);
        await downloadFile(file, `${translate('reportByPayments')}, ${legalEntityName}`, 'xlsx');
    }
}

export const paymentsService = new PaymentsService();
